import { render } from "./Index_affix.vue?vue&type=template&id=5f3f363b"
import script from "./Index_affix.vue?vue&type=script&lang=js"
export * from "./Index_affix.vue?vue&type=script&lang=js"

import "./Index_affix.vue?vue&type=style&index=0&id=5f3f363b&lang=css"
script.render = render

export default script